<template>
  <div class="yesScore" v-if="count > 0">
    <!-- 搜索输入框 -->
    <div class="search">
      <el-input
        placeholder="请输入参赛作品编号"
        v-model="searchInput"
        clearable
        @change="onChnage()"
        class="searchInput"
      >
      </el-input
      ><el-button @click="searchBM()" type="primary" class="searchStyle"
        >搜索</el-button
      >
    </div>
    <!-- 作品列表 -->
    <ul class="boxs" v-if="yesOpusLists.length > 0">
      <li v-for="item in yesOpusLists" :key="item.bm_id">
        <div class="csbh">参赛编号：{{ item.bm_id }}</div>
        <div class="auto" @click="toScoreChange(item.bm_id)">
          <video
            v-if="item.path"
            width="100%"
            preload="meta"
            height="100%"
            :controls="false"
            style="object-fit: fill"
            ref="video"
          >
            <source :src="aliyunURL + item.path" type="video/mp4" />
            <source src="movie.ogg" type="video/ogg" />
            您的浏览器不支持Video标签。
          </video>
        </div>
        <div class="text">
          <p>
            <el-tooltip
              class="item"
              effect="dark"
              content="评分差异大于十分"
              placement="right"
              v-if="item.difference == 1"
            >
              <i
                style="color: red; padding-left: 5px"
                class="el-icon-warning"
              ></i>
            </el-tooltip>
            <!-- {{ item.intro }} -->
          </p>
          <span class="span">{{ item.addDate }}</span>
        </div>
        <div v-if="Array.isArray(item.score)">
          <div
            class="allscore"
            @click="toScoreChange(item.bm_id)"
            v-for="(items, index) in item.score"
            :key="index"
          >
            <span>{{ items.username }}</span>
            <span v-if="items.state == 1" class="span2"
              >已打分&nbsp;:&nbsp;{{ items.score }}</span
            >
            <span class="span2" v-else>未打分</span>
            <span class="span3"><i class="el-icon-arrow-right"></i></span>
          </div>
        </div>
        <div v-else class="allscore" @click="toScoreChange(item.bm_id)">
          <span>已打分</span><span class="span2">{{ item.score }}</span
          ><span class="span3"><i class="el-icon-arrow-right"></i></span>
        </div>
      </li>
    </ul>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pageSize.page"
      layout="prev, pager, next"
      :total="count"
      :page-size="6"
      :hide-on-single-page="false"
    >
    </el-pagination>
  </div>
</template>

<script>
import { judgesGetOpusLists } from "../JudegeAPI/user";
import { getTokenJ } from "../../assets/js/Storage-J";
export default {
  data() {
    return {
      searchInput: "",
      yesOpusLists: [],
      aliyunURL: "https://vod.gyycbj.com/",
      count: 0,
      pageSize: {
        page: 1,
        limit: 6,
      },
    };
  },
  created() {
    this.getOpusListHandle();
  },
  mounted() {},
  methods: {
    // 搜索编号
    searchBM() {
      this.pageSize.page = 1;
      this.getOpusListHandle();
    },
    // 输入框change
    onChnage() {
      if (this.searchInput == "") {
        this.pageSize.page = 1;
        this.getOpusListHandle();
      }
    },
    // 分页切换
    handleCurrentChange(val) {
      this.pageSize.page = val;
      this.getOpusListHandle();
    },
    // 获取作品列表
    async getOpusListHandle() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)",
      });
      const { data: res } = await judgesGetOpusLists({
        ...this.pageSize,
        j_id: getTokenJ().j_id,
        state: 1,
        sousuo: this.searchInput,
        phase: localStorage.getItem("phase"),
      });
      loading.close();
      if (res.code !== "0000") {
        return this.$message(res.msg);
      }
      this.count = res.data.count;
      this.yesOpusLists = res.data.list;
    },
    toScoreChange(id) {
      this.$router.push({
        name: "yesScoreDetails",
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.yesScore {
  .search {
    display: flex;
    margin: 0 30px;
    padding-top: 15px;
    .searchInput {
      width: 200px;
      ::v-deep .el-input__inner:focus {
        border-color: #5b2d9b;
      }
    }
    .searchStyle {
      color: #ffffff;
      background-color: #5b2d9b;
      border-color: rgba(0, 0, 0, 0);
    }
  }
  background-color: #fff;
  padding-bottom: 15px;
  ::v-deep .el-pagination {
    text-align: center;
    .el-pager li.active {
      color: #ffffff;
    }
  }
  .boxs {
    display: flex;
    flex-wrap: wrap;
    padding: 15px;
    padding-top: 0;
    li {
      width: 31%;
      cursor: pointer;
      margin: 15px;
      height: min-content;
      border: 1px solid #d5d5d5;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 20px 0 0 0;
      .csbh {
        text-align: center;
        color: #666;
        padding-bottom: 5px;
      }
      .auto {
        height: 220px;
        box-sizing: border-box;
        margin: 0 20px;
      }
      .text {
        padding: 0 20px;
        box-sizing: border-box;
        padding-bottom: 14px;
        p {
          color: #333333;
          font-size: 20px;
          padding: 15px 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        p:hover {
          color: #333089;
        }
        .span {
          display: block;
          text-align: right;
          color: #999;
        }
      }
      .allscore {
        border-top: 1px solid #d5d5d5;
        display: flex;
        padding: 10px 20px;
        cursor: pointer;
        justify-content: space-between;
        span {
          font-weight: 600;
          color: #5b2d9b;
          flex: 1;
          i {
            font-weight: 800;
          }
        }
        .span2 {
          text-align: center;
        }
        .span3 {
          text-align: right;
        }
      }
      .fraction {
        border-top: 1px solid #e5e5e5;
        height: 54px;
        display: flex;
        justify-content: space-between;
        line-height: 54px;
        color: #5b2d9b;
        font-size: 20px;
        padding: 0 21px;
        .span2 {
          font-weight: 700;
        }
      }
    }
  }
}
</style>
